import { sumBy } from "lodash";
import moment from "moment";
import { DateUtils } from "~app/common/utils/date-utils";
import { IValidationRuleSettings } from "~app/common/validation/IValidationRuleSettings";
import { IHandelssortimentProdukt } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { HandelssortimentDTO } from "../../../../../app/common/models/handelssortiment/HandelssortimentDTO";
import { ValidationErrorLevels } from "../../../../common/validation/ValidationErrorLevels";
import { ValidationScopes } from "../../../../common/validation/ValidationScopes";
import { ValidationContext } from "../../../../common/validation/validationContext";

export class HandelssortimentValidation {
    static init(
        handelssortiment: HandelssortimentDTO,
        produkter: IHandelssortimentProdukt[]): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;

        const produktRules = produkter.map<IValidationRuleSettings[]>((p, i) => [
            {
                errorLevel: ValidationErrorLevels.error,
                id: 10 + i,
                message: { text: "Produkt saknas" },
                model: () => p.produktId,
                name: `produktId${i}`,
                required: true
            }
        ]).flat(1);

        context.create(ValidationScopes.skapa).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: "Du måste ange ett handelssortimentsnamn" },
                model: () => handelssortiment.namn,
                name: "handelssortimentNamn",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                message: { text: "Handelssortimentsgrupp saknas" },
                model: () => handelssortiment.handelssortimentsgruppId,
                name: "handelssortimentGrupp",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 3,
                expression: (newVal, oldVal) => {
                    if (!newVal) {
                        return false;
                    }
                    // Användarinmatad kontroll (år-månad-dag) ELLER bundet strängvärde från en Date som kommer från DTO/backend (år-månad-dag-T-tid-tidzon-etc)
                    return (moment(newVal, DateUtils.dateformat, true).isValid() || moment((newVal as string).substring(0, 10), DateUtils.dateformat, true).isValid());
                },
                message: { text: "Ogiltigt datum" },
                model: () => handelssortiment.giltigFrom,
                name: "giltligFrom"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () => {
                    if (produkter) {
                        const typerToCheck = [
                            undefined,
                            null,
                            "Min",
                            "Mix"
                        ];
                        const productsToCheck = produkter.filter(p => typerToCheck.some(t => t === p.fordelningstyp));
                        const sum = sumBy(productsToCheck, p => p.andel);
                        if (sum <= 100) {
                            return true;
                        }
                    }
                    return false;
                },
                id: 7,
                message: { text: "Totala andelen av alla produkters Min och Mix får inte överstiga 100" },
                model: () => produkter,
                name: "produkterAndel"
            },
            {
                applicable: x => typeof x !== "object",
                errorLevel: ValidationErrorLevels.error,
                expression: (x) => x == null || (x <= 100 && x >= 0),
                id: 8,
                message: { text: "Andel måste vara mellan 0 och 100" },
                model: () => produkter,
                name: "produktAndel"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 9,
                expression: (newVal) => {
                    if (!newVal) {
                        return false;
                    }
                    return handelssortiment.densitetSkotning > 0;
                },
                message: { text: "Måste vara > 0" },
                model: () => handelssortiment.densitetSkotning,
                name: "densitetSkotning",
                required: true
            },
            ...produktRules
        ]);
        return context;
    }
}
